module.exports = __webpack_public_path__ + "images/emoji/haircut.5af4e317a7b1e8f220d4.png";